<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">支付统计<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <!--                <template #prefix>-->
                <!--                  <p class="select-itm">门店<span>|</span></p>-->
                <!--                </template>-->
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
<!--        <div class="content-button">-->
<!--          <div>-->
<!--&lt;!&ndash;            <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--          </div>-->

<!--        </div>-->
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="statDate" label="日期" v-if="checkColList.indexOf('日期') > -1"></el-table-column>
            <el-table-column property="week" label="星期" v-if="checkColList.indexOf('星期') > -1"/>
            <el-table-column property="shopName" label="门店" v-if="checkColList.indexOf('门店') > -1"></el-table-column>
            <el-table-column property="" label="预约单" v-if="checkColList.indexOf('预约单') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.preBookNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="普通单" v-if="checkColList.indexOf('普通单') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.generalNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="wechatMoney" label="微信" v-if="checkColList.indexOf('微信') > -1"></el-table-column>
            <el-table-column property="alipayMoney" label="支付宝" v-if="checkColList.indexOf('支付宝') > -1"></el-table-column>
            <el-table-column property="shouqianbaMoney" label="收钱吧" v-if="checkColList.indexOf('收钱吧') > -1"></el-table-column>
            <el-table-column property="otherMoney" label="其他" v-if="checkColList.indexOf('其他') > -1"></el-table-column>
            <el-table-column property="" label="网上支付" v-if="checkColList.indexOf('网上支付') > -1">
              <template #default="scope">
                <span>{{scope.row.webMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="deductionPayMoney" label="充值抵扣" v-if="checkColList.indexOf('充值抵扣') > -1"></el-table-column>
            <el-table-column property="deductionGiveMoney" label="赠送抵扣" v-if="checkColList.indexOf('赠送抵扣') > -1"></el-table-column>
            <el-table-column property="meituanMoney" label="美团" v-if="checkColList.indexOf('美团') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.meituanMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="tiktokMoney" label="抖音" v-if="checkColList.indexOf('抖音') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.tiktokMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="总金额" v-if="checkColList.indexOf('总金额') > -1">
              <template #default="scope">
                <span>{{scope.row.allMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor">
              <template #default="scope">
                {{scope.row.remark}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="sumDataList"
              style="width: 100%;"
              v-loading="listLoading"
              size="default"
              border
          >
            <el-table-column property="" label="汇总"></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="preBookNum" label="预约单"></el-table-column>
            <el-table-column property="generalNum" label="普通单"></el-table-column>

            <el-table-column property="wechatMoney" label="微信"></el-table-column>
            <el-table-column property="alipayMoney" label="支付宝"></el-table-column>
            <el-table-column property="shouqianbaMoney" label="收钱吧"></el-table-column>
            <el-table-column property="otherMoney" label="其他"></el-table-column>

            <el-table-column property="statDate" label="网上支付">
              <template #default="scope">
                <span>{{scope.row.webMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="deductionPayMoney" label="充值抵扣"></el-table-column>
            <el-table-column property="deductionGiveMoney" label="赠送抵扣"></el-table-column>
            <el-table-column property="meituanMoney" label="美团"></el-table-column>
            <el-table-column property="tiktokMoney" label="抖音"></el-table-column>
            <el-table-column property="statDate" label="总金额">
              <template #default="scope">
                <span>{{scope.row.allMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label=""></el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getPaymentStatPageList, getPageStatSummary} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange_noL";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { decimal_NUM, add } from "@/assets/shared/util";
import MeiTuanPrice from "@/views/stat/components/MeiTuanPrice";
import remarkDialog from "@/views/stat/components/PaymentRemarkDialog";
import paymentNumDialog from "@/views/stat/components/paymentNumDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "StatPayment",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList, unLock },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['日期', '星期', '门店', '预约单', '普通单', '充值抵扣', '赠送抵扣', '网上支付', '微信', '支付宝', '收钱吧', '其他', '美团', '抖音', '总金额', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 2,

      upChargeLoading: false,


    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPaymentStatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getSumPage(param)
          this.pageDataList.map(item => {
            item.webMoney = add([item.wechatMoney, item.alipayMoney, item.shouqianbaMoney, item.otherMoney])
            item.allMoney = add([item.wechatMoney, item.alipayMoney, item.shouqianbaMoney, item.otherMoney, item.meituanMoney, item.deductionPayMoney, item.deductionGiveMoney, item.tiktokMoney])
          })

        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    getSumPage(param) {
      getFormData(getPageStatSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          let result = data['data'];
          result.webMoney = add([result.wechatMoney, result.alipayMoney, result.shouqianbaMoney, result.otherMoney])
          result.allMoney = add([result.webMoney, result.meituanMoney, result.deductionPayMoney, result.deductionGiveMoney, result.tiktokMoney])
          this.sumDataList.push(result)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      // if(column.label == '备注') {
      //   Dialog.open({
      //     title: '用户备注',
      //     component: UserRemarkDialog,
      //     data: {
      //       id: row.id,
      //       width: '800px'
      //     },
      //     close: () => {
      //       row['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }

      //充值记录
      if(column.label == '美团') {
        let priceForm = Object.assign({}, row);
        Dialog.open({
          title: '美团金额',
          component: MeiTuanPrice,
          data: {
            priceForm: priceForm,
            type: 1,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '抖音') {
        let priceForm = Object.assign({}, row);
        Dialog.open({
          title: '抖音金额',
          component: MeiTuanPrice,
          data: {
            priceForm: priceForm,
            type: 2,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '更新备注',
          component: remarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '预约单' || column.label == '普通单') {
        let paymentForm = Object.assign({}, row);
        let type = column.label == '预约单'?1:2
        Dialog.open({
          title: column.label,
          component: paymentNumDialog,
          data: {
            paymentForm: paymentForm,
            type: type,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }


    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
